import React from 'react';
import '../../styles/organisms/notification-detail.scss';

export const NotificationDetail = props => (
  <div
    className='dialog-md dialog--modal NotificationDetail'
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <div className='dialog-md__header'>
      <span className='dialog-md__title'>{props.dialogTitle}</span>
    </div>
    <div className='dialog-md__body'>
      <p className='dialog-md__body__content-text'>{props.dialogContent}</p>
    </div>
    <div className='dialog-md__footer-horizontal'>
      <button
        className='btn-fixedsize--sub'
        onClick={() => {
          props.onClose();
        }}
      >
        戻る
      </button>
      {!props.isHideBlueButton && (
        <button
          className='btn-fixedsize'
          onClick={() => {
            props.onExecute();
          }}
        >
          {props.dialogBlueButtonTitle}
        </button>
      )}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/NotificationDetail.jsx